import { PublicLayout } from "../../components/PublicLayout";
import { StatusTag } from "../../components/StatusTag";

export function WeekendBoostPage() {
  return (
    <PublicLayout title="週末耀旺" subtitle="週末限時活動">
      <section className="limited-event-panel">
        <StatusTag label="限時" tone="new" />
        <h2>週五 00:00 至週日 23:59</h2>
        <p>週末充值不提高常態回饋，但額外多寶石碎片與週末紅包券。</p>
      </section>
      <section className="tier-list">
        <article className="tier-card active">
          <StatusTag label="週末加碼" tone="active" />
          <h3>單筆 3,000</h3>
          <p>寶石碎片 +1，每人每週限一次</p>
        </article>
        <article className="tier-card active">
          <StatusTag label="週末加碼" tone="claim" />
          <h3>單筆 5,000</h3>
          <p>週末紅包券 1 張，每人每週限一次</p>
        </article>
        <article className="tier-card">
          <StatusTag label="說明" tone="pending" />
          <h3>平日與週末差異</h3>
          <p>平日有常態回饋與週通行證進度；週末額外疊加本頁獎勵。</p>
        </article>
      </section>
    </PublicLayout>
  );
}
